@if (multiProductForms) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="multiProductForms.menuParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Menu Header </label>
            </div>
            <clickatell-form-validation [controlName]="'menuHeader'"
            [form]="multiProductForms.menuParams"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="multiProductForms.menuParams" id="menuHeader"
              [formControlName]="'menuHeader'" [placeholder]="PLACEHOLDERS.menuHeader"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Body Text </label>
              </div>
              <clickatell-form-validation [controlName]="'bodyText'"
              [form]="multiProductForms.menuParams"></clickatell-form-validation>
              <textarea class="control-textArea" activeForm [activeForm]="multiProductForms.menuParams"
                id="bodyText" [formControlName]="'bodyText'"
              [placeholder]="PLACEHOLDERS.bodyText"></textarea>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Sub Header </label>
                <label class="control-optional">Optional</label>
              </div>
              <input class="control-input" activeForm [activeForm]="multiProductForms.menuParams" id="subHeader"
                [formControlName]="'subHeader'" [placeholder]="PLACEHOLDERS.subHeader"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Button text </label>
                </div>
                <clickatell-form-validation [controlName]="'buttonText'"
                [form]="multiProductForms.menuParams"></clickatell-form-validation>
                <input class="control-input" [disabled] activeForm [activeForm]="multiProductForms.menuParams" id="buttonText"
                  [formControlName]="'buttonText'" [placeholder]="PLACEHOLDERS.buttonText"/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Catalogue ID </label>
                  </div>
                  <clickatell-form-validation [controlName]="'catalogId'"
                  [form]="multiProductForms.menuParams"></clickatell-form-validation>
                  <input class="control-input" activeForm [activeForm]="multiProductForms.menuParams" id="catalogId"
                    [formControlName]="'catalogId'" [placeholder]="PLACEHOLDERS.catalogId"/>
                  </div>
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Product Source </label>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'isDynamic'"></app-cms>
                    </div>
                    <clickatell-button-toggle #isDynamic [data]="TOGGLE_DATA" id="isDynamic"
                    [formControlName]="'isDynamic'"></clickatell-button-toggle>
                  </div>
                </ng-container>
                <ng-container>
                  <div class="control-div">
                    @if (!isDynamic.state) {
                      @for (productId of multiProductForms.productIds.controls; track productId; let index = $index) {
                        <clickatell-form-validation [controlName]="'id'"
                        [form]="productId"></clickatell-form-validation>
                        <div class="productId-container" [formGroup]="productId">
                          <input class="control-input" [formControlName]="'id'" [id]="'productId-' + index"
                            [placeholder]="PLACEHOLDERS.productId"/>
                            <button tooltip
                              tooltipPosition="topRight"
                              tooltipText="Minimum 1 product ID required"
                              [isVisible]="isMin"
                              id="removeProduct"
                              class="productId-delete-btn" (click)="removeProduct(index)">
                              <div class="productId-delete-btn-img"
                              [ngClass]="{'disable': isMin, 'active': !isMin}"></div>
                            </button>
                          </div>
                        }
                      } @else {
                        <ng-container [formGroup]="multiProductForms.productIds.controls[0]">
                          <clickatell-form-validation [controlName]="'id'"
                          [form]="multiProductForms.productIds.controls[0]"></clickatell-form-validation>
                          <div class="control-div">
                            <input class="control-input" [formControlName]="'id'" id="dynamic-productId"
                              [placeholder]="PLACEHOLDERS.productId"/>
                            </div>
                          </ng-container>
                        }
                        @if (!isDynamic.state) {
                          <div class="control-icon-btn"  tooltip
                            tooltipPosition="top"
                            tooltipText="Cannot add more than 30 products"
                            [isVisible]="isMax">
                            <button id="addProduct" class="control-btn" (click)="addProduct()"
                              [disabled]="isMax" >
                              <img class="btn-icon" src='./assets/svg/addVariableIcon.svg'/>
                              <span class="btn-icon-label">
                                Add Product
                              </span>
                            </button>
                          </div>
                        }
                      </div>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Logic
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <ng-container>
                      <div class="control-div">
                        <label class="control-label"> Point To </label>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                        @if (nodeFlowDetails) {
                          <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                            [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                            [name]="'next'"
                            [form]="multiProductForms.menuParams"
                            [stepId]="nodeFlowDetails.stepId">
                          ></next-selector>
                        }
                      </div>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
              </div>
            }
